import React from 'react';

import { action, computed } from 'mobx';
import { observer } from 'mobx-react';

import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import Button from 'bz-core-controls/controls/general/button';

export interface IProps {
  list: any;
  src: string;
  title: string;
  value: string;

  onChange: (key: string, value: any) => void;
  onRemove: (key: string) => void;
}

export interface IPayload {
  payload: string;
  text: string;
}

@observer
class Alternate extends React.Component<IProps> {
  render() {
    const { items, onChange, onRemove } = this;
    const { title, value } = this.props;

    return (
      <>
        <div className="col=start-1 alternates item col-span-4">
          <FieldSelect items={items} label={title} value={value} onChange={onChange} />
        </div>
        <Button className="alternates remove" label="X" small={true} onClick={onRemove} />
      </>
    );
  }

  @computed
  get items() {
    const { list } = this.props;

    return Object.entries(list).map(([key, value]) => {
      return { payload: key, text: value };
    });
  }

  @action.bound
  onChange(e) {
    const { src, onChange } = this.props;

    onChange(src, e.target.value);
  }

  @action.bound
  onRemove() {
    const { src, onRemove } = this.props;

    onRemove(src);
  }
}

export default Alternate;
